import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import { RadioButton } from "primereact/radiobutton";
import { InputText } from "primereact/inputtext";
import { validateInputText } from "../../../utilities/ValidateUtil";
import classNames from "classnames";

export default function P404Dialog({ dialog, setDialog, submitForm, submitted }) {
    const [data, setData] = useState({
        userId: "",
        actionCode: "",
        caseNo: "",
        caseName: "",
        status: "A",
    });

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };

    useEffect(() => {
        if (dialog.dialog === true && dialog.action === "แก้ไข") {
            setData(dialog.data);
        } else {
            setData({
                userId: "",
                actionCode: "",
                caseNo: "",
                caseName: "",
                status: "A",
            });
        }
    }, [dialog.data]);

    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button
                    // label={dialog.action}
                    label={"บันทึก"}
                    icon="pi pi-save"
                    onClick={() => submitForm(data)} autoFocus className="p-button p-button-success" />
                <Button label="ยกเลิก" icon="pi pi-times" onClick={() => setDialog(false)} className="p-button-danger p-button" />
            </div>
        );
    };

    return (
        <>
            <Dialog
                header="เพิ่ม/แก้ไข ลักษณะงาน"
                visible={dialog.dialog} style={{ width: "45vw" }}
                className="p-fluid ___widthDialog"
                footer={renderFooter()} onHide={() => setDialog(false)}
                blockScroll={true}
                maximizable={true}
            >
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-field p-col-12 p-md-12">
                        <label htmlFor="caseNo">รหัสลักษณะงาน</label>
                        <InputText
                            value={data.caseNo}
                            type="text"
                            id="caseNo"
                            onChange={(e) => onInputTextChange(e, "caseNo")}
                            disabled={dialog.action && dialog.action === 'แก้ไข'}
                            className={classNames({ "p-invalid": dialog.action && dialog.action === 'บันทึก' })}
                        />
                        {submitted && !data.caseNo && validateInputText("classNames", "รหัสลักษณะงาน")}
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <label htmlFor="caseName">ชื่อลักษณะงาน</label>
                        <InputText
                            value={data.caseName}
                            type="text"
                            onChange={(e) => onInputTextChange(e, "caseName")}
                            className="p-invalid"
                        // className={classNames({ "p-invalid": submitted && !data.caseName })}
                        />
                        {submitted && !data.caseName && validateInputText("caseName", "ชื่อลักษณะงาน")}
                    </div>
                    <div className="p-field p-col-12 p-md-12">
                        <label htmlFor="cb1">สถานะ</label>
                        <div className="p-field-radiobutton" style={{ marginTop: "0.45rem", marginBottom: "0.45rem" }}>
                            <RadioButton inputId="status_1" name="status" value="A" 
                            onChange={(e) => onInputTextChange(e, "status")} checked={data.status === "A"} 
                            className={classNames({ "p-invalid": submitted && !data.status })} />
                            <label htmlFor="appointment_location1" style={{ marginRight: ".5rem" }}>
                                ใช้งาน
                            </label>
                            <RadioButton
                                inputId="status_2"
                                name="status"
                                value="I"
                                onChange={(e) => onInputTextChange(e, "status")}
                                checked={data.status === "I"}
                                // className="p-invalid"
                                className={classNames({ "p-invalid": submitted && !data.status })}
                            />
                            <label htmlFor="appointment_location2" style={{ marginRight: ".5rem" }}>
                                ไม่ใช้งาน
                            </label>
                        </div>
                        {submitted && !data.status && validateInputText("status", "สถานะ")}
                    </div>
                    <br />
                </div>
            </Dialog>
        </>
    );
}
